module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4fjNo"))).then(() => parcelRequire('2KbAe'));